import React, { useEffect } from "react";
import classes from "../../components/CommonGrid/commonGrid.module.css";
import QuickInfoCardCommon from "../../components/QuickInfoCardCommon";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoanBoarded } from "../../store/reducers/submitALoanSlice/api";
import { useAbortController } from "../../hooks/useAbortController";

const LoanBoarded = () => {
  const { signal } = useAbortController();
  const dispatch = useDispatch();
  const yearToDate = useSelector(
    (state) => state.submitALoan.loanBoarded.yearToDate
  );
  const monthToDate = useSelector(
    (state) => state.submitALoan.loanBoarded.monthToDate
  );
  const lenderId = useSelector((state) => state.account.lenderId);

  useEffect(() => {
    dispatch(fetchLoanBoarded({ lenderId, signal }));
  }, [dispatch, lenderId]);

  return (
    <div className={`rounded pb-2`} style={{ background: "white" }}>
      <div className="my-5 p-5 rounded w-100">
        <div>
          <div className="pb-5">
            <h2 className={classes.h2}>Loan Boarded</h2>{" "}
          </div>
        </div>
        <QuickInfoCardCommon
          backgroundColor="#ECF4FF"
          class_name="bg-secondary"
          label="Year to Date"
          info={yearToDate}
        />
        <QuickInfoCardCommon
          backgroundColor="#ECF4FF"
          class_name="mt-3 bg-secondary"
          label="Month to Date"
          info={monthToDate}
        />
      </div>
    </div>
  );
};

export default LoanBoarded;
